import { doorStatusReducer, stopRequestReducer } from './components/DoorStatus/reducers';
import { eventLogReducer } from './components/EventLog/reducers';
import { actualSpeedReducer, autoStopReducer, locationReducer, playingReducer, scenarioPlayReducer, scenarioReducer, scenarioStatusReducer, speedReducer, tripReducer, } from './components/MapControl/reducers';
import { passengerReducer } from './components/Passengers/reducers';
import { audioReducer } from './components/AudioComponent/reducers';
import { displaysReducer } from './components/Displays/reducers';
import { scenarioStateReducer } from './containers/TestController/reducers';
import { playModeReducer } from './containers/ModeChooserTabs/reducers';
import { scenarioSpeedReducer } from './components/VehicleController/reducers';
export default {
    passengers: passengerReducer,
    audio: audioReducer,
    doorStatus: doorStatusReducer,
    stopRequest: stopRequestReducer,
    trip: tripReducer,
    actualSpeed: actualSpeedReducer,
    location: locationReducer,
    playing: playingReducer,
    maximumSpeed: speedReducer,
    autoStop: autoStopReducer,
    eventLog: eventLogReducer,
    displays: displaysReducer,
    scenario: scenarioReducer,
    scenarioPlay: scenarioPlayReducer,
    scenarioStatus: scenarioStatusReducer,
    scenarioState: scenarioStateReducer,
    scenarioSpeed: scenarioSpeedReducer,
    playMode: playModeReducer,
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers.ts
// module id = 1823
// module chunks = 0